import store from '@/store';
import { NavigationGuardNext, Route } from 'vue-router';
import { RouteName } from '@/router/types';

export function badgesGuard(to: Route, from: Route, next: NavigationGuardNext): boolean {
  if (!store.getters['tenant/isBadgesAvailable']) {
    next({ name: RouteName.Community });
  } else {
    next();
  }
  return true;
}
